// 1. Import `extendTheme`
import { extendTheme, theme as baseTheme, } from "@chakra-ui/react"

// 2. Call `extendTheme` and pass your custom values
export const theme = extendTheme({
    shadows: {
        ...baseTheme.shadows,
        outline: '0 0 0 3px #9f7aea',
    },
    colors: {
        ...baseTheme.colors,
        primary: '#6b46c1',
        gray: {
            ...baseTheme.colors.gray,
            750: '#212732',
        },
    },
})
